import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { CgSync } from "react-icons/cg";
import { IoDocumentTextOutline } from "react-icons/io5";
import { TbWorldWww } from "react-icons/tb";
import { TiUserOutline } from "react-icons/ti";
import { motion } from "framer-motion";
import { RiLoaderLine } from "react-icons/ri";

export default function MessageBubble({
  message,
  botlogourl,
  handelRetry,
  cosui,
}) {
  console.log("message", message);
  if (message?.isbot) {
    return (
      <div className="flex flex-col gap-2 max-w-[94%] px-2 mb-5">
        {!message?.error && (
          <div className="flex w-fit max-w-full gap-2 items-start">
            <img
              className="w-6 h-6 2xl:w-8 2xl:h-8 rounded-full"
              src={botlogourl || "https://via.placeholder.com/150"}
              alt="Bot avatar"
            />
            <div className="flex flex-col w-full rounded-lg text-base 2xl:text-lg">
              <div dangerouslySetInnerHTML={{ __html: message?.msgg }}></div>
              {message?.loading && (
                <RiLoaderLine
                  size={16}
                  id={`${message.key}-loader`}
                  className="animate-spin text-gray-500 mt-1"
                />
              )}
              {message?.citation?.length > 0 && (
                <div className="w-full text-base mt-3">
                  <div className="w-full h-[1px] bg-black mb-2" />
                  <div className="font-bold mb-2">Reference Link</div>
                  {message?.citation.map((item, i) => {
                    let displayText = item.uri;

                    if (item.type === "html") {
                      displayText =
                        item.uri.length > 100
                          ? item.uri.slice(0, 100) + "..."
                          : item.uri;
                    } else {
                      const split = item.uri.split(`${item.type}/`);
                      const part = split[1] || item.uri;
                      displayText =
                        part.length > 100 ? part.slice(0, 100) + "..." : part;
                    }

                    return (
                      <div
                        key={i}
                        className="w-full flex gap-2 break-all items-center">
                        {item.type === "pdf" && <BsFileEarmarkPdfFill />}
                        {item.type === "text" && <IoDocumentTextOutline />}
                        {item.type === "html" && <TbWorldWww />}
                        <a
                          href={item.uri}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline">
                          {decodeURIComponent(displayText)}
                        </a>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        {message?.error && (
          <div className="flex w-fit max-w-full gap-2 items-start">
            <img
              className="w-6 h-6 2xl:w-8 2xl:h-8 rounded-full"
              src={botlogourl || "https://via.placeholder.com/150"}
              alt="Bot avatar"
            />
            <div className="flex flex-col w-full rounded-lg text-base 2xl:text-lg">
              <p className="text-red-500">{message?.msgg}</p>
            </div>
            <motion.button
              initial={{ scale: 1 }}
              whileTap={{ scale: 0.9, rotate: -20 }}
              whileHover={{ scale: 1.1, rotate: 180 }}
              onClick={(e) => handelRetry(e, message)}
              className="w-6 h-6 2xl:w-8 2xl:h-8 rounded-full">
              <CgSync className="w-full h-full" />
            </motion.button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="w-full flex my-2 ">
      <div className="flex gap-2 flex-1 sm:w-[94%] px-2 items-end">
        <div className="w-6 h-6 2xl:w-8 2xl:h-8 rounded-full">
          <TiUserOutline className="w-full h-full" />
        </div>
        <p className=" text-base font-semibold 2xl:text-lg ">{message.msgg}</p>
      </div>
    </div>
  );
}
